import React from 'react'

const FooterPadrao = ({ generatedAt = '' }) => {
  return (
    <div className="report-footer" style={{
      padding: '10px 16px', borderTop: '1px solid #e5e7eb', marginTop: '12px', fontSize: '12px'
    }}>
      <p style={{ margin: 0 }}>Gerado em: {generatedAt}</p>
      <p style={{ margin: 0 }}>Etiquetando - Sistema de Etiquetas</p>
    </div>
  )
}

export default FooterPadrao